// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__272JN","topBottomGutter":"Layout_topBottomGutter__1a8mA"};